var exports = {
  "kL": "xe533113f--f15fa6--container",
  "jq": "xe533113f--f15fa6--contact",
  "Fu": "xe533113f--f15fa6--contact-logo",
  "bm": "xe533113f--f15fa6--contact-content",
  "ao": "xe533113f--f15fa6--contact-description",
  "fN": "xe533113f--f15fa6--contact-logo_img",
};

module.exports = exports;
